import { makeStyles } from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  fullWidth: {
    backgroundColor: "#fafafa",
    maxWidth: 1970,
    padding: 0,
  },

  btnFullscreen: {
    position: "fixed",
    background: "#b01010",
    color: "#fff",
    right: 25,
    bottom: 25,

    "&:hover": {
      background: "#960d0d",
      color: "#fff",
    },
  },

  wrapperSeals: {
    padding: 40,

    display: "flex",
    flexDirection: "column",
    gap: 40,

    [theme.breakpoints.down("sm")]: {
      padding: 0,
    },
  },

  wrapperTitle: {
    display: "flex",
    flexDirection: "column",
    gap: 10,

    "& .MuiTypography-h1": {
      fontSize: 24,
      color: "#0C0F18",
      fontWeight: "bold",
    },

    "& .MuiTypography-span": {
      fontSize: 16,
      console: "#5D5656",
    },
  },

  wrapperFiles: {
    display: "flex",
    gap: 10,
    justifyContent: "flex-start",
    flexDirection: "column",
  },

  files: {
    display: "flex",
    gap: 10,
    justifyContent: "flex-start",
  },

  filesPreview: {
    display: "flex",
    gap: 10,
    justifyContent: "flex-start",
    flexDirection: "column",
  },

  containerPreview: {
    display: "flex",
    gap: 10,
    justifyContent: "flex-start",
  },

  preview: {
    display: "flex",
    gap: 10,
    justifyContent: "flex-start",
    alignItems: "center",
    maxWidth: 260,
    width: "100%",
    borderRadius: 6,
    border: "1px solid #D4D2D2",
    padding: "8px 10px",

    "& [data-element='preview-content']": {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      justifyContent: "flex-start",

      "& .MuiTypography-h6": {
        fontSize: 14,
        color: "#5D5656",
      },

      "& .MuiTypography-subtitle2": {
        fontSize: 12,
        color: "#818284",
      },
    },

    "& [data-element='remove']": {
      minWidth: 24,
      width: 24,
      height: 24,
      marginLeft: "auto",
      border: "none",
      background: "transparent",
      cursor: "pointer",
      outline: "none",
    },
  },

  containerSeal: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
    alignItems: "center",
    padding: 20,
    margin: 0,

    maxWidth: 320,
    width: "100%",

    "& h6": {
      fontSize: 20,
      color: "#0C0F18",
      fontWeight: "bold",
    },

    "& > span": {
      fontSize: 16,
      color: "#5D5656",
      textAlign: "center",
      padding: "0 5px",
    },

    "& label": {
      maxWidth: 180,
      width: "100%",
      height: 51,
      borderRadius: 6,
      color: "#fff",
      cursor: "pointer",

      fontSize: 16,
      fontWeight: "bold",

      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 10,
      transition: "opacity 0.3s ease-in-out",

      "&[data-element='import']": {
        background: "#FF314A",
        marginTop: 'auto',

        "&:hover": {
          opacity: 0.8,
        },
      },

      "&[data-element='add']": {
        background: "#1BA441",

        "&:hover": {
          opacity: 0.8,
        },
      },
    },
  },

  wrapperDetailsSeal: {
    display: "flex",
    flexDirection: "column",
    gap: 10,

    "& h2": {
      fontSize: 24,
      color: "#0C0F18",
      fontWeight: "bold",
    },

    "& > label": {
      display: "flex",
      flexDirection: "column",
      gap: 10,

      "& h5": {
        fontSize: 16,
        fontWeight: "bold",
      },

      "& [data-element='input']": {
        maxWidth: 650,
        width: "100%",
        borderRadius: 6,
        fontSize: 16,
        fontWeight: "normal",
        color: "#383838",
        outline: "none",

        "& > .MuiInputBase-formControl": {
          height: 40,
          padding: 10,
        },
      },

      "& [data-element='select']": {
        maxWidth: 650,
        width: "100%",
        borderRadius: 6,
        fontSize: 16,
        fontWeight: "normal",
        color: "#383838",
        outline: "none",

        "& > .MuiSelect-select": {
          padding: 10,
        },

        "& > .MuiOutlinedInput-notchedOutline": {
          height: 45,
          padding: 10,
        },
      },

      '& [data-element="period"]': {
        display: "flex",
        alignItems: "flex-start",
        flexDirection: "column",
        gap: 10,

        "& > div": {
          display: "flex",
          alignItems: "center",
          gap: 10,

          "& span": {
            fontSize: 16,
            color: "#383838",
          },

          '& [data-element="date"], & [data-element="time"]': {
            maxWidth: 150,
            width: "100%",
            borderRadius: 6,
            fontSize: 16,
            fontWeight: "normal",
            color: "#383838",
            outline: "none",

            "& > .MuiInputBase-formControl": {
              height: 40,
              padding: 10,

              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #D4D2D2",
              },
            },
          },
        },
      },

      '& [data-element="color"]': {
        maxWidth: 150,
        width: "100%",
        borderRadius: 6,
        fontSize: 16,
        fontWeight: "normal",
        color: "#383838",
        outline: "none",

        "& > .MuiInputBase-formControl": {
          height: 40,
          padding: 10,
        },
      },
    },
  },

  sealPreview: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    marginTop: 40,

    "& h5": {
      fontSize: 24,
      fontWeight: "bold",
    },

    "& > .MuiButton-root": {
      maxWidth: 240,
      width: "100%",
      background: "rgba(27, 164, 65, 0.1)",
      boxShadow: "none",
      borderRadius: 6,

      "& .MuiButton-label": {
        fontSize: 14,
        fontWeight: "bold",
        color: "#1BA441",
        textTransform: "none",
      },
    },
  },

  sealActions: {
    display: "flex",
    gap: 10,
    justifyContent: "flex-start",
    paddingTop: 20,
    marginTop: 40,
    borderTop: "1px solid #D4D2D2",

    "& > .MuiButton-root": {
      maxWidth: 150,
      width: "100%",
      borderRadius: 6,
      boxShadow: "none",

      "&[data-element='cancel']": {
        background: "#F4F4F4",
        border: "1px solid #E0E0E0",

        "& .MuiButton-label": {
          fontSize: 14,
          fontWeight: "bold",
          color: "#818284",
          textTransform: "none",
        },
      },

      "&[data-element='save']": {
        background: "#1BA441",

        "& .MuiButton-label": {
          fontSize: 14,
          fontWeight: "bold",
          color: "#fff",
          textTransform: "none",
        },
      },
    },
  },

  modalPreviewSeal: {
    "& > .MuiDialog-container .MuiDialog-paper": {
      maxWidth: "100%",
      width: "90%",
    },
  },

  previewSeal: {
    display: "flex",
    gap: 20,

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },

    '& [data-element="title"]': {
      fontSize: 16,
      fontWeight: "bold",
      color: "#fff",
      background: "#D81717",
      padding: 10,
      borderRadius: 6,
      maxWidth: 232,
      width: "100%",
    },

    '& [data-element="shelf"]': {
      position: "relative",

      '& [data-element="flag"]': {
        textAlign: "center",
        marginBottom: 10,

        borderBottomRightRadius: 4,
        borderBottomLeftRadius: 4,

        "& h3": {
          fontSize: 14,
        },

        "& p": {
          fontSize: 14,
          color: "#383838",
        },
      },

      '& [data-element="frete"]': {
        textAlign: "center",
        marginBottom: 10,
        maxWidth: "50%",

        borderRadius: 4,

        "& h3": {
          fontSize: 14,
        },
      },

      '& [data-element="shelf-foto"]': {
        maxWidth: 232,
        width: "100%",
        borderRadius: 6,
        border: "1px solid #E0E0E0",
        boxShadow: "none",
        position: "relative",

        [theme.breakpoints.down("sm")]: {
          maxWidth: 212,
          width: "100%",
        },
      },

      '& [data-element="shelf-foto"]': {},
    },

    '& [data-element="product-page"]': {
      display: "flex",
      flexDirection: "column",
      gap: 10,

      '& [data-element="bradcrumb"]': {
        margin: "10px 0",

        "& > .MuiTypography-body1": {
          fontSize: 14,
          color: "#5D5656",
          display: "flex",
          alignItems: "center",
          gap: 5,
        },
      },

      '& [data-element="preview"]': {
        [theme.breakpoints.down("sm")]: {
          display: "none",
        },
      },

      '& [data-element="product-page-content"]': {
        display: "flex",
        gap: 20,

        [theme.breakpoints.down("sm")]: {
          flexDirection: "column",
        },

        '& [data-element="flag"]': {
          textAlign: "center",
          marginBottom: 10,

          borderBottomRightRadius: 4,
          borderBottomLeftRadius: 4,

          "& h3": {
            fontSize: 14,
          },

          "& p": {
            fontSize: 14,
            color: "#383838",
          },
        },

        '& [data-element="frete"]': {
          textAlign: "center",
          marginBottom: 10,
          maxWidth: "50%",

          borderRadius: 4,

          "& h3": {
            fontSize: 14,
          },
        },

        '& [data-element="product-page-foto"]': {
          position: "relative",

          '& [data-element="foto"]': {
            [theme.breakpoints.down("sm")]: {
              maxWidth: 280,
              width: "100%",
              height: 260,
            },
          },
        },
      },
    },
  },

  "ul.MuiList-root": {
    paddingLeft: 15,
  },

  teste: {},
}));

export default useStyle;
